// 配置路由相关信息
import VueRouter from 'vue-router'
import Vue from 'vue'
// import store from '../store/index'

const Vescor = () => import('../views/Vescor.vue')
const Home = () => import('../views/Home.vue')
const BrandPage = () => import('../views/BrandPage.vue')
const CooperationPage = () => import('../views/CooperationPage.vue')
const ProductPage = () => import('../views/ProductPage.vue')
const ProductCatalog = () => import('../views/ProductCatalog.vue')
const ProductDetailPage = () => import('../views/ProductDetailPage.vue')
const ContactPage = () => import('../views/ContactPage.vue')
const TechPage = () => import('../views/TechPage.vue')
// 假设你在 productDetails 目录下有两个二级页面组件
import ProductDetail1 from '@/views/productDetails/ProductDetail1.vue';
import ProductDetail2 from '@/views/productDetails/ProductDetail2.vue';
import ProductDetail3 from '@/views/productDetails/ProductDetail3.vue';
import ProductDetail4 from '@/views/productDetails/ProductDetail4.vue';
import ProductDetail5 from '@/views/productDetails/ProductDetail5.vue';
import ProductDetail6 from '@/views/productDetails/ProductDetail6.vue';
import ProductDetail7 from '@/views/productDetails/ProductDetail7.vue';


// const IndibaView = () => import('../views/IndibaView.vue')
// const LpgView = () => import('../views/LpgView.vue')
// const VescorView = () => import('../views/VescorView.vue')
// const HaiFeiXiuView = () => import('../views/HaiFeiXiuView.vue')

// 安装插件
Vue.use(VueRouter)

// 创建VueRouter对象
const routes = [
    {
        path: '/',
        name: 'Vescor',
        redirect: '/Vescor',
    },
    {
        path: '/Vescor',
        name: 'Vescor',
        component: Vescor,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {}, // 不需要身份验证
    },
    {
        path: '/Home',
        name: 'Home',
        component: Home,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {}, // 不需要身份验证
    },
    {
        path: '/BrandPage',
        name: 'BrandPage',
        component: BrandPage,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {}, // 不需要身份验证
    },
    {
        path: '/CooperationPage',
        name: 'CooperationPage',
        component: CooperationPage,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {}, // 不需要身份验证
    },
    {
        path: '/ProductPage',
        name: 'ProductPage',
        component: ProductPage,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {}, // 不需要身份验证
    },
    {
        path: '/ProductCatalog',
        name: 'ProductCatalog',
        component: ProductCatalog,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {}, // 不需要身份验证
    },
    {
        path: '/ProductDetailPage',
        name: 'ProductDetailPage',
        component: ProductDetailPage,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        children: [
            {
                path: 'detail1',
                name: 'ProductDetail1',
                component: ProductDetail1,
                meta: {
                    firstLevelTitle: '面膜',
                    secondLevelTitle: '膠原蛋白蜜肌面膜'
                }
            },
            {
                path: 'detail2',
                name: 'ProductDetail2',
                component: ProductDetail2,
                meta: {
                    firstLevelTitle: '面膜',
                    secondLevelTitle: '黑鑽至臻炭煥顏面膜'
                }
            },
            {
                path: 'detail3',
                name: 'ProductDetail3',
                component: ProductDetail3,
                meta: {
                    firstLevelTitle: '彈力賦活系列',
                    secondLevelTitle: '彈力賦活精華水'
                }
            },
            {
                path: 'detail4',
                name: 'ProductDetail4',
                component: ProductDetail4,
                meta: {
                    firstLevelTitle: '彈力賦活系列',
                    secondLevelTitle: '彈力賦活抗皺精華液'
                }
            },
            {
                path: 'detail5',
                name: 'ProductDetail5',
                component: ProductDetail5,
                meta: {
                    firstLevelTitle: '彈力賦活系列',
                    secondLevelTitle: '彈力賦活抗皺精華霜'
                }
            },
            {
                path: 'detail6',
                name: 'ProductDetail6',
                component: ProductDetail6,
                meta: {
                    firstLevelTitle: '賦顏菁萃系列',
                    secondLevelTitle: '賦顏菁萃精華油'
                }
            },
            {
                path: 'detail7',
                name: 'ProductDetail7',
                component: ProductDetail7,
                meta: {
                    firstLevelTitle: '賦顏菁萃系列',
                    secondLevelTitle: '柔光水潤粉底液'
                }
            }
        ],
        meta: {}, // 不需要身份验证
    },
    
    {
        path: '/ContactPage',
        name: 'ContactPage',
        component: ContactPage,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {}, // 不需要身份验证
    },
    {
        path: '/TechPage',
        name: 'TechPage',
        component: TechPage,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {}, // 不需要身份验证
    },


    // {
    //     path: '/indiba-view',
    //     name: 'indiba-view',
    //     component: IndibaView,
    //     // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
    //     meta: {}, // 不需要身份验证
    // },
    // {
    //     path: '/lpg-view',
    //     name: 'lpg-view',
    //     component: LpgView,
    //     // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
    //     meta: {}, // 不需要身份验证
    // },
    // {
    //     path: '/vescor-view',
    //     name: 'vescor-view',
    //     component: VescorView,
    //     // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
    //     meta: {}, // 不需要身份验证
    // },
    // {
    //     path: '/HaiFeiXiu-view',
    //     name: 'HaiFeiXiu-view',
    //     component: HaiFeiXiuView,
    //     // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
    //     meta: {}, // 不需要身份验证
    // },
]

// 
const router = new VueRouter({
    // mode: 'history',
    routes,
    scrollBehavior() {
        // to, from, savedPosition
        return { x: 0, y: 0 }
    }
})

// let isFetchingUserInfo = false; // 用于防止重复请求
// let isRedirecting = false; // 防止重复重定向

// 路由守卫
router.beforeEach(async (to, from, next) => {
    console.log(`Trying to navigate from ${from.path} to ${to.path}`);
    // const openid = store.state.OPENID;

    // 如果当前路径不需要认证，直接放行
    // if (to.meta && !to.meta.requireAuth && to.path !== '/Home') {
    //     return next();
    // }


    // // 检查 openid 是否存在
    // if (!openid) {
    //     // 确保不是在尝试重定向到相同路径
    //     if (to.path !== '/Home') {
    //         return next({ path: '/Home' });
    //     }
    //     return next(); // 如果已经在 /Home，继续导航
    // }

    // // openid 存在，获取用户信息
    // if (!isFetchingUserInfo) {
    //     isFetchingUserInfo = true;
    //     await store.dispatch('fetchUserInfo', openid);
    //     isFetchingUserInfo = false;
    // }

    // const isPartner = store.state.USERINFO.qy && store.state.USERINFO.qy.checkstate === '已通过';

    // if (isPartner) {
    //     // 如果是合伙人，确保导航到 order-review 页面
    //     if (to.path !== '/order-review' && from.path !== '/order-review') {
    //         console.log(`Redirecting to /order-review`);
    //         return next({ path: '/order-review' });
    //     }
    // } else {
    //     // 如果不是合伙人，确保导航到 partner-status 页面
    //     if (to.path !== '/partner-status') {
    //         return next({ path: '/partner-status' });
    //     }
    // }

    // 默认放行
    next();
});


// 将router对象传入到Vue实例中
export default router